import { put, takeLatest } from "redux-saga/effects";
import { requestRestaurants, setRestaurants } from "../..";
import getMongoRestaurants from "./mongodb";

function* fetchRestaurantsSaga() {
  const restaurants = yield getMongoRestaurants();
  yield put(setRestaurants(restaurants));
}

export default function*() {
  yield takeLatest(requestRestaurants, fetchRestaurantsSaga);
}
